import initialState from './initialState';


export default function orderReducer(state = {...initialState.order}, action) {
	switch(action.type) {

		case 'CREATE_NEW_ORDER':
			return {...initialState.order};

		case 'ADD_ORDER_LINE':
			return {
				...state,
				lines: action.newLines,
				total: action.newTotal
			};

		case 'MODIFY_ORDER_LINE':
			return {
				...state,
				lines: action.newLines,
				total: action.newTotal
			};

		case 'REMOVE_ORDER_LINE':
            return {
                ...state,
                lines: action.newLines,
                total: action.newTotal
            };

		case 'CLEAR_ORDER':
            return {
				...state,
				lines: [],
				total: 0
			};

		default:
			return {
				...state
            };
	}
}



// WEBPACK FOOTER //
// ./src/store/reducers/order.js